/**
 * Site layout.
 *
 * The navbar and footer used to live inline in this file — 478 lines carrying
 * 14 raw hex literals, three hard-coded `Inter` font stacks and a
 * `backdrop-filter` that is banned by name in tokens.css. They are now real
 * components on the token layer:
 *
 *   ./Navbar.jsx   ./Footer.jsx   ./SiteChrome.css
 *
 * They are re-exported here so `@/components/shared/Layout` keeps working for
 * everything that already imports from it (App.js), and so this module has one
 * job: composing them around a page.
 */
import Navbar from './Navbar';
import Footer from './Footer';
import './SiteChrome.css';

export { Navbar, Footer };

export const Layout = ({ children }) => (
  <div className="chrome-shell">
    <Navbar />
    <main className="chrome-shell__main">{children}</main>
    <Footer />
  </div>
);

export default Layout;
